import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';

import Label from 'components/_utility/Label';

import { getPendingPackConflicts, getPendingPack, getConflictChoice } from 'src/redux/bike/selectors';

import AccessoryChoiceGroup from 'components/AccessoryChoiceGroup/AccessoryChoiceGroup';
import PackChoiceGroup from 'components/PackChoiceGroup/PackChoiceGroup';

import { closeAccessoryResolution, resolvePackAccessoryConflict, setConflictChoice } from 'src/redux/bike/actions';

import { Wrap, Heading, Title, Description, Actions, ConfirmButton, CancelButton } from '../ConflictingAccessories/ConflictingAccessories.styled';

const ConflictingPack = () => {
  const dispatch = useDispatch();

  const pendingPack = useSelector(getPendingPack);
  const conflictingPackAccessories = useSelector(getPendingPackConflicts);
  const choice = useSelector(getConflictChoice);

  const handleChoose = choiceId => dispatch(setConflictChoice(choiceId));

  return (
    <Wrap>
      <Title>
        <Label name="packAccessoryConflictsTitle" />
      </Title>

      <Description>
        <Label name="packAccessoryConflictsDescription" />
      </Description>

      <Scrollbar noDefaultStyles>
        <Heading>
          <Label name="packLabel" />
        </Heading>

        <PackChoiceGroup id="pack" pack={pendingPack} onChoose={handleChoose} selected={choice === 'pack'} />

        <Heading>
          <Label name="conflictsLabel" />
        </Heading>

        <AccessoryChoiceGroup
          id="accessories"
          accessories={conflictingPackAccessories}
          onChoose={handleChoose}
          selected={choice === 'accessories'}
        />

        <Actions>
          <ConfirmButton primary onClick={() => dispatch(resolvePackAccessoryConflict())} disabled={!choice}>
            <Label name="confirmLabel"></Label>
          </ConfirmButton>
          <CancelButton onClick={() => dispatch(closeAccessoryResolution())}>
            <Label name="cancelLabel"></Label>
          </CancelButton>
        </Actions>
      </Scrollbar>
    </Wrap>
  );
};

export default ConflictingPack;
